import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ValidationMessageList from '../../../validation/component/ValidationMessageList'
import LabelInput from '../../../form/component/LabelInput'
import Input from '../../../form/component/Input'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PHOTO_CHECKIN_WIDGET } from '../../../process/ui-definition/process-ui'


const PhotoCheckinWidget = ({ readOnly, context, changeProcessContext, saveProcessContext, validationMessageList }) => {
    if (!currentUserHasAccess(PHOTO_CHECKIN_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Photo Checkin Result">
            <Row>
                <Column size={12}>
                    <ValidationMessageList validationMessageList={validationMessageList}/>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Go to aligner number upper jaw">
                        <Input
                            name="gotoAlignerNumberUpper"
                            object={context}
                            type="number"
                            onChange={changeProcessContext}
                            onBlur={saveProcessContext}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Go to aligner number lower jaw">
                        <Input
                            name="gotoAlignerNumberLower"
                            type="number"
                            object={context}
                            onChange={changeProcessContext}
                            onBlur={saveProcessContext}
                        />
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

PhotoCheckinWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default PhotoCheckinWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/PhotoCheckinWidget.js